export default (step: number, counter: 0 | 1 | 2 | 3) => {
  const base = counter !== 3 ? (75 - 24) / 2 : (75 - 24) / 2 - 12;

  return step * counter + base;
};
